import { api } from 'utility';
import {
  getToggleDeligationUrl,
  getUsageRestrictionsUrl,
  getSubscriptionServiceUrl,
  getSubscriptionPlanUrl,
  getSubscriptionRequestUrl,
} from 'URLs';
export function getSubscriptions(params) {
  return api.get(getSubscriptionPlanUrl(), { params }).then((res) => res.data);
}

export function getSubscriptionsRequest(planId, params) {
  return api.post(getSubscriptionRequestUrl(planId), params).then((res) => res.data);
}

export function getUsageRestrictions(data, params) {
  return api.post(getUsageRestrictionsUrl(), data, { params }).then((res) => res.data);
}

export function getConsumers(params) {
  return api.get(getSubscriptionServiceUrl(), { params }).then((res) => res.data);
}

export function changeDelegationStatus(id, newStatus) {
  return newStatus
    ? api.post(getToggleDeligationUrl(id)).then((res) => res.data)
    : api.delete(getToggleDeligationUrl(id)).then((res) => res.data);
}

export default {
  getSubscriptions,
  getUsageRestrictions,
  getConsumers,
  changeDelegationStatus,
};
